import { jsx as _jsx } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import Seo, { SITE_ORIGIN } from './Seo';
import { guidesRegistry } from '../../data/guides/guidesRegistry';
/**
 * Setzt Meta-Tags + strukturierte Daten (TechArticle + Breadcrumb) für
 * Anleitungsseiten. Titel/Beschreibung kommen lokalisiert aus der guidesRegistry.
 */
const GuideSeo = ({ route, fallbackTitle, fallbackDescription }) => {
    const { i18n } = useTranslation();
    const lang = (i18n.language || 'en').split('-')[0];
    const guide = guidesRegistry.find((g) => g.route === route);
    const title = guide?.title[lang] || guide?.title['en'] || fallbackTitle || 'Anleitung';
    const description = guide?.description[lang] ||
        guide?.description['en'] ||
        fallbackDescription ||
        title;
    const keywords = guide?.tags.join(', ');
    const url = `${SITE_ORIGIN}${route}`;
    const articleJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'TechArticle',
        headline: title,
        description,
        inLanguage: lang,
        url,
        author: { '@type': 'Organization', name: 'TitanicTurtle' },
        publisher: {
            '@type': 'Organization',
            name: 'TitanicTurtle',
            logo: {
                '@type': 'ImageObject',
                url: `${SITE_ORIGIN}/media/logobasicoutlined.png`,
            },
        },
    };
    const breadcrumbJsonLd = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
            { '@type': 'ListItem', position: 1, name: 'Hilfe & Anleitungen', item: `${SITE_ORIGIN}/help` },
            { '@type': 'ListItem', position: 2, name: title, item: url },
        ],
    };
    return (_jsx(Seo, { title: `${title} – Garmin Watchface Anleitung`, description: description, canonicalPath: route, type: "article", keywords: keywords, jsonLd: [articleJsonLd, breadcrumbJsonLd] }));
};
export default GuideSeo;
